<template>
  <div class="denglus">
     <div class="denglulogo">
       <img src="../assets/head-logo.png" alt="">
     </div>
 <!-- 关闭返回首页按钮 -->
    <router-link to="/">
      <div class="cno"></div>
    </router-link>
      <!-- 登录界面 -->
      <div class="denglus-cont">
          <div class="denglus-titles">
                 <p>欢迎登录全国铁道供电微课大赛！</p>
            </div>
       <!-- 输入内容 -->
       <div class="denglus-nrs">
           <p>登录身份</p>
           <!-- 身份选择 -->
    <el-select @change="identity()"  id="denglu-sel" value-key="weid"  v-model="selValue" placeholder="请选择登录身份">
    <el-option 
      v-for="item in options"
      :key="item.weid"
      :label="item.label"
      :value="item"
      >
    </el-option>
  </el-select>
  <div class="kong"></div>
            <!-- 账号密码 -->
   <p>用户名</p>
          <el-input id="denglu-psname" placeholder="请输入用户名" v-model="psname" ></el-input>   
   <div class="kong"></div>
   <p>账号密码</p>
        <el-input id="denglu-psword" placeholder="请输入账号密码" v-model="psword" show-password></el-input>  


       </div>
       <div class="denglus-btnall">
<button @click="denglu()" class="denglus-btns">立即登录</button>

<router-link to="/zhuce">
<button class="zhuces-btns">立即注册</button>
</router-link>

       </div>


      </div>
  </div>
</template>

<script>
import denglu from '../css/DengLu.css'
import axios from 'axios'


import { mapActions,mapState,mapMutations,Authorization} from 'vuex'
export default {
    data(){
        return{
options: [
       {
         weid:1,
          value: '选项1',
          label: '普通用户'
        },
         {
            weid:2,
          value: '选项2',
          label: '参赛教师',
        },
        {
            weid:3,
          value: '选项3',
          label: '评委专家',
        },
        {
           weid:  4,
          value: '选项4',
          label: '管理员'
        }
        ],
        selValue: '',//selValue.weid是type
        psword:'',  //密码
        psname:'',  //账号
      
       
   
        }
    },
    methods:{
    

      identity(){
// console.log(this.selValue.weid);
      },
      denglu(){
        
        let type = this.selValue.weid;
        let username = this.psname;
        let password = this.psword;
        if (this.selValue.weid==undefined) {
          this.$message.error({
            message:'请选择账号身份',
            offset:100
          })
        }
         // 发送数据
      let postdata = this.$qs.stringify({
        username:username,
        password:password,
        type:type,  
      });
      if (type==1 ||type==2 || type==4) {
        
    
         axios({
  method: 'post',
  url: this.$apiUrl+'/index.php/login/login',
 data: postdata
 
}).then(res=>{
  // console.log(res.data);
  if (res.data.code == 0) {
  this.$message.error({
    message:res.data.msg,
    offset:100
  });
    return false;
  }else if (res.data.code == 1 && type==1 || type ==2) {
    this.$message({
      message:res.data.msg,
      offset:200,
      type:'success'
    });
     this.token = res.data.data.token;
    //console.log(token); //储存token
    let username = this.psname;
     let password = this.psword;
     let userinfo = {
      name:this.psname,
      password:this.psword,
      token:res.data.data.token,
      type:type
    }
     //把用户数据传入state
    this.$store.commit('logduser',userinfo);
    this.$router.push('/'); 
  }else if (res.data.code == 1&&type==4) {
      
    // window.open(res.data.data.url);
     window.location.href = res.data.data.url
     console.log(res.data.data.url);
  }
}).catch(error=>{
  console.log(error);
})
  }
// 评委端登录
 if (type == 3) {
   axios({
  method: 'post',
  url: this.$apiUrl+'/jury.php/login/login',
  data:postdata
}).then(res =>{
  // console.log(res.data)
  if (res.data.code == 1) {
    this.$message({
      message:res.data.msg,
      offset:100,
       type:'success'
    })

 window.location.href = "http://ke.yunlearning.com:8082/LoginTk.html?token="+res.data.data.token;
  }else if (res.data.code == 0) {
    this.$message({
      message:res.data.msg,
      offset:100
     
    });
   
  }
})
 }
 },
 created() {
    // 按下回车执行登录按钮点击事件
    var _self = this
    document.onkeydown = function(e) {
      var key = window.event.keyCode
      if (key == 13) {
        _self.denglu()
      }
    }
  }

    },
    mounted:function(){
this.created()
    }
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/DengLu.vue